import { gsap } from 'gsap';
import { debounce } from 'lodash';

export default function() {
	const tabWrappers = document.querySelectorAll('[data-tab-wrapper]');

	if (tabWrappers.length === 0) return;

	const ANIM_PROP = {open: {opacity: 1}, close: {opacity: 0}};
	const ANIM_DUR = 0.5;
	const ANIM_EASE = 'power1.out';
	const ANIM_DELAY = 0;

	tabWrappers.forEach((tabWrapper) => {

		const tabButtons = tabWrapper.querySelectorAll('[data-tab-button]');
		const tabContainer = tabWrapper.querySelector('[data-tab-container]');
		const tabContents = tabWrapper.querySelectorAll('[data-tab-content]');
		tabButtons.length > 0 && tabContents.length > 0 ? tabHandle(tabButtons, tabContainer, tabContents) : false;
	});

	function tabHandle(tabButtons, tabContainer, tabContents) {

		let containerHeight = 0;

		tabContainer ? setWrapperHeight(tabContents[0]) : false;

		setActiveAnchor(tabButtons[0].dataset.tabButton);

		tabButtons.forEach(button => {
			button.addEventListener('click', () => {
				const activeTab = button.dataset.tabButton;
				setActiveAnchor(activeTab);
			});
		});

		function setWrapperHeight(content) {
			containerHeight = content.scrollHeight;
			tabContainer.style.height = containerHeight + 'px';
		}

		function setActiveAnchor(anchor) {
			tabButtons.forEach(but => {
				but.classList.remove('is-active');
			});
			tabContents.forEach((tab, ind) => {
				const tabContent = tab.dataset.tabContent;
				if (!ANIM_PROP) {
					if (tabContent === anchor) {
						tab.classList.add('is-active');
						tabButtons[ind].classList.add('is-active');
					}
					else {
						tab.classList.remove('is-active');
					}
				}
				else {
					const animSettings = {
						duration: ANIM_DUR,
						ease: ANIM_EASE,
						delay: ANIM_DELAY,
					};
					if (tabContent === anchor) {
						const animTo = ANIM_PROP.open;
						const callbacks = {
							onStart: ()=> {
								tab.classList.add('is-active');
								tabButtons[ind].classList.add('is-active');
								setWrapperHeight(tab);
							},
						};
						Object.assign(animTo, animSettings, callbacks);
						gsap.to(tab, animTo);
					} else {
						const animTo = ANIM_PROP.close;
						gsap.to(tab, {...animTo, onComplete: ()=> {
							tab.classList.remove('is-active');
						}});
					}
				}
			});
		}

		const debouncedHeight = debounce(() => {
			setWrapperHeight(tabContainer.querySelector('[data-tab-content].is-active'));
		}, 300);
		window.addEventListener('resize', debouncedHeight);
	}
}
